export const ListQueryKey = 'activitySubAuthRecords';
export const DetailQueryKey = 'activitySubAuthRecord';
export const Urls = {
  selectUrl: '/subAuthRecord/list',
  updateUrl: '/subAuthRecord/update',
  deleteUrl: '/subAuthRecord/delete',
  createUrl: '/subAuthRecord/create',
  detailUrl: '/subAuthRecord/info'
};